import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import DialogContent from '@mui/material/DialogContent'
import InstantWinWheel from './InstantWinWheel'
import analytics from 'global/AnalyticsData'
import { getUserType } from 'global/context/sub-contexts/userContext'
import { userTypeEnum } from 'services/user'
import './InstantWinModal.scss'

/**

    wheelConfig={
        title
        bodyCopy
        footerCopy
        prizeId - sent to InstantWinWheel
        shouldSpin - sent to InstantWinWheel
    }


*/
const InstantWinModal = ({
  wheelConfig = {},
  wheelTheme,
  data,
  isModalOpen,
  handleCloseModal = () => {},
  button,
  handleAfterSpin = () => {},
  className=""
}) => {
  const isGuest = getUserType() === userTypeEnum.GUEST
  const [top, setTop] = useState((parseInt(window.embedPerceivedTop) + 20) + "px")
  const backdropStyle = {
    backdropFilter: 'blur(2px)',
    overflow: "scroll"
  }
  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    // minHeight: 'var(--content-min-height)',
    position: 'fixed',
    top: top,
  }

  useEffect(() => {
    if (isModalOpen) {
      analytics.stepEvent('instant_win_modal_open', {}, { isGuest })
      setTop((parseInt(window.embedPerceivedTop) + 20) + "px")
    }
  }, [isModalOpen])

  // using visibility: hidden helps minimize layout shift
  let forfeitStyle = {}
  if (wheelConfig.hideForfeit) {
    forfeitStyle = { visibility: 'hidden' }
  }
  const modalCloseButtonhandler = () => {
    handleCloseModal()
    analytics.stepEvent('instant_win_forfeit_click', {}, { isGuest })
  }
  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={backdropStyle} 
            
      >
        <DialogContent style={style}>
            
          <div className={`instant-win-modal ${className}`}>
            <div className="instant-win-modal-content">
              <button
                className={`modal-close`}
                onClick={handleCloseModal}
                aria-label="Next"
              ></button>
              <h2 className="title">{wheelConfig.title}</h2>
              <h3 className="subtitle">{wheelConfig.bodyCopy}</h3>
              <InstantWinWheel
                data={data}
                button={button}
                wheelConfig={wheelConfig}
                wheelTheme={wheelTheme}
                handleAfterSpin={handleAfterSpin}
              />
              <div
                className="tandc"
                dangerouslySetInnerHTML={{ __html: wheelConfig.footerCopy }}
              />
              <div className="forfeit-container" style={forfeitStyle}>
                <span onClick={modalCloseButtonhandler} className="forfeit">
                  I'd like to forfeit
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Modal>
    </>
  )
}

export default InstantWinModal
